
  
  export const scanConfigs = {
    basic: {
      tabs: [
        {
          id: "1",
          title: "Basic",
          fields: [
            { id: "Name", label: "Name", type: "text", placeholder: "Enter Name", required: true },
            { id: "Description", label: "Description", type: "textarea", placeholder: "Enter Description",  height: "100px" },
            { id: "target", label: "Target", type: "textarea", placeholder: "Enter Target" },
            {
              id: "scanType",
              label: "Scan Type",
              type: "select",
              options: [
                { value: "full", label: "Full Scan" },
                { value: "quick", label: "Quick Scan" },
              ],
            },
            
          ],
        },
  // Reusing the schedule section here
      ],
    },
    Advance: {
      tabs: [
        {
          id: "1",
          title: "Advance",
          fields: [
            { id: "target", label: "Target", type: "text", placeholder: "Enter Target" },
            {
              id: "scanType",
              label: "Scan Type",
              type: "select",
              options: [
                { value: "full", label: "Full Scan" },
                { value: "quick", label: "Quick Scan" },
              ],
            },
          ],
        },
      ],
    },
    Malware: {
      tabs: [
        {
          id: "1",
          title: "Basic",
          fields: [
            { id: "Name", label: "Name", type: "text", placeholder: "Enter Name", required: true },
            { id: "Description", label: "Description", type: "textarea", placeholder: "Enter Description",  height: "100px" },
            { id: "target", label: "Target", type: "textarea", placeholder: "Enter Target" },

            {
              id: "scanType",
              label: "Scan Type",
              type: "select",
              options: [
                { value: "full", label: "Full Scan" },
                { value: "quick", label: "Quick Scan" },
              ],
            },
          ],
        },
      ],
    },
    webApp: {
      tabs: [
        {
          id: "1",
          title: "Basic",
          fields: [
            { id: "Name", label: "Name", type: "text", placeholder: "Enter Name", required: true },
            { id: "Description", label: "Description", type: "textarea", placeholder: "Enter Description",  height: "100px" },
            { id: "target", label: "Target", type: "textarea", placeholder: "Enter Target" },
            {
              id: "scanType",
              label: "Scan Type",
              type: "select",
              options: [
                { value: "full", label: "Full Scan" },
                { value: "quick", label: "Quick Scan" },
              ],
            },
          ],
        },
  // Reusing the schedule section here
      ],
    },
    networkScan: {
      tabs: [
        {
          id: "1",
          title: "Basic",
          fields: [
            { id: "Name", label: "Name", type: "text", placeholder: "Enter Name", required: true },
            { id: "Description", label: "Description", type: "textarea", placeholder: "Enter Description",  height: "100px" },
            { id: "target", label: "Target", type: "textarea", placeholder: "Enter Target" },
            
          ],
        },
  // Reusing the schedule section here
      ],
    },
    codeScan : {
      tabs: [
        {
          id: "1",
          title: "Basic",
          fields: [
            { id: "repoURL", label: "Repository URL", type: "text", placeholder: "Enter Repository URL" },
            { id: "branch", label: "Branch", type: "text", placeholder: "Enter Branch Name" },
            { id: "scanType", label: "Scan Type", type: "select", options: [
              { value: "full", label: "Full Scan" },
              { value: "incremental", label: "Incremental Scan" },
            ] },
          ],
        },
        {
          id: "2",
          title: "Advanced Settings",
          fields: [
            { id: "codeDepth", label: "Code Depth", type: "select", options: [
              { value: "shallow", label: "Shallow" },
              { value: "deep", label: "Deep" },
            ] },
            { id: "vulnSeverity", label: "Vulnerability Severity", type: "select", options: [
              { value: "critical", label: "Critical" },
              { value: "high", label: "High" },
              { value: "medium", label: "Medium" },
              { value: "low", label: "Low" },
            ] },
            { id: "alertNotification", label: "Alert Notification", type: "checkbox", options: [
              { value: "enabled", label: "Enabled" },
              { value: "disabled", label: "Disabled" },
            ] },
          ],
        },

      ],
    },
    Cloud: {
      tabs: [
        {
          id: "1",
          title: "Cloud",
          fields: [
            { id: "target", label: "Target", type: "text", placeholder: "Enter Target" },
            {
              id: "scanType",
              label: "Scan Type",
              type: "select",
              options: [
                { value: "full", label: "Full Scan" },
                { value: "quick", label: "Quick Scan" },
              ],
            },
          ],
        },
      ],
    },
    Database: {
      tabs: [
        {
          id: "1",
          title: "Database",
          fields: [
            { id: "target", label: "Target", type: "text", placeholder: "Enter Target" },
            {
              id: "scanType",
              label: "Scan Type",
              type: "select",
              options: [
                { value: "full", label: "Full Scan" },
                { value: "quick", label: "Quick Scan" },
              ],
            },
          ],
        },
      ],
    },
    apiScan: {
      tabs: [
        {
          id: "1",
          title: "Basic",
          fields: [
            
            { id: "Name", label: "Name", type: "text", placeholder: "Enter Name", required: true },
            { id: "Description", label: "Description", type: "textarea", placeholder: "Enter Description",  height: "100px" },
            { id: "target", label: "API Endpoint", type: "textarea", placeholder: "Enter Target" },
            { id: "OpenAPI", label: "OpenAPI Specification", type: "text", placeholder: "OpenAPI Url", required: true }]
        },
  // Reusing the schedule section here
      ],
    },
    Configurations: {
      tabs: [
        {
          id: "1",
          title: "Configurations",
          fields: [
            { id: "target", label: "Target", type: "text", placeholder: "Enter Target" },
            {
              id: "scanType",
              label: "Scan Type",
              type: "select",
              options: [
                { value: "full", label: "Full Scan" },
                { value: "quick", label: "Quick Scan" },
              ],
            },
          ],
        },
      ],
    },
    SBOM: {
      tabs: [
        {
          id: "1",
          title: "Basic",
          fields: [
            { id: "Name", label: "Name", type: "text", placeholder: "Enter Name", required: true },
            { id: "Description", label: "Description", type: "textarea", placeholder: "Enter Description",  height: "100px" },
            { id: "sbomFormat", label: "SBOM Format", type: "select", options: [
              { value: "spdx", label: "SPDX" },
              { value: "cyclonedx", label: "CycloneDX" },
              { value: "custom", label: "Custom" },
            ] },
            { 
              id: "sbomFile", 
              label: "Upload File", 
              type: "file", 
              placeholder: "Upload SBOM file (e.g., SPDX, CycloneDX)",
              accept: ".json,.xml,.spdx,.cdx,.spdx.json,.cdx.json"  // Define accepted file types here
            },
            { id: "sbomVersion", label: "SBOM Version", type: "text", placeholder: "Enter SBOM Version" },
          ],
        },
        {
          id: "2",
          title: "Advanced Settings",
          fields: [
            { id: "sbomValidate", label: "Validate SBOM", type: "checkbox", options: [
              { value: "enabled", label: "Enabled" },
              { value: "disabled", label: "Disabled" },
            ] },
            { id: "sbomIncludeDevDependencies", label: "Include Dev Dependencies", type: "checkbox", options: [
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ] },
          ],
        },
 // Schedule Section comes after Advanced Settings
      ],
    },
    SCA: {
      tabs: [
        {
          id: "1",
          title: "Basic",
          fields: [
            { id: "scaTool", label: "SCA Tool", type: "text", placeholder: "Enter SCA Tool (e.g., Snyk, WhiteSource)" },
            { id: "scaReport", label: "SCA Vulnerability Report", type: "file", placeholder: "Upload SCA Report" },
            { id: "scaLicenses", label: "License Compliance", type: "checkbox", options: [
              { value: "compliant", label: "Compliant" },
              { value: "non-compliant", label: "Non-Compliant" },
            ] },
          ],
        },
        {
          id: "2",
          title: "Advanced Settings",
          fields: [
            { id: "scaSeverity", label: "Severity Level", type: "select", options: [
              { value: "critical", label: "Critical" },
              { value: "high", label: "High" },
              { value: "medium", label: "Medium" },
              { value: "low", label: "Low" },
            ] },
            { id: "scaAutoFix", label: "Enable Auto-Fix", type: "checkbox", options: [
              { value: "enabled", label: "Enabled" },
              { value: "disabled", label: "Disabled" },
            ] },
          ],
        },
 // Schedule Section comes after Advanced Settings
      ],
    },

    Container: {
      tabs: [
        {
          id: "1",
          title: "Basic Settings",
          fields: [
            { id: "containerImage", label: "Container Image", type: "text", placeholder: "Enter container image (e.g., nginx:latest)" },
            { id: "containerRegistry", label: "Container Registry", type: "text", placeholder: "Enter registry (e.g., Docker Hub, ECR)" },
            { id: "containerScan", label: "Enable Image Scanning", type: "checkbox", options: [
              { value: "enabled", label: "Enabled" },
              { value: "disabled", label: "Disabled" },
            ] },
          ],
        },
        {
          id: "2",
          title: "Advanced Settings",
          fields: [
            { id: "resourceLimits", label: "Resource Limits", type: "text", placeholder: "e.g., CPU: 500m, Memory: 256Mi" },
            { id: "networkPolicies", label: "Network Policies", type: "checkbox", options: [
              { value: "enabled", label: "Enabled" },
              { value: "disabled", label: "Disabled" },
            ] },
            { id: "securityContext", label: "Security Context", type: "select", options: [
              { value: "privileged", label: "Privileged" },
              { value: "restricted", label: "Restricted" },
            ] },
          ],
        },
       
      ],
    },
    
  //   mobileApp: {
  //     tabs: [
  //       {
  //         id: "1",
  //         title: "Basic",
  //         fields: [
  //           { id: "appId", label: "App ID", type: "text", placeholder: "Enter Mobile App ID" },
  //           {
  //             id: "platform",
  //             label: "Platform",
  //             type: "select",
  //             options: [
  //               { value: "android", label: "Android" },
  //               { value: "ios", label: "iOS" },
  //             ],
  //           },
  //         ],
  //       },
  // // Reusing the schedule section here
  //     ],
  //   },
    
  };
  